<template>
    <el-drawer
      title="门店显示"
      :visible.sync="isShow"
      direction="rtl"
      size="60%"
      :destroy-on-close="true"
      :show-close="true"
      :wrapperClosable="true"
      @close="closeDrawer"
    >
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopStore">新建</el-button>
          <el-button type="warning" plain size="small" icon="el-icon-edit" :disabled="multipleSelection.length != 1"
            @click="editShopStore(null)">修改</el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteShopStore(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span title="下载模板" class="icon-box" @click="importTemplate">
            <Icon color="#606266">
              <ArrowDown />
            </Icon>
          </span>
          <span class="icon-box" title="导入数据" @click="isImport">
            <Icon color="#606266">
              <ArrowExportUp24Regular />
            </Icon>
          </span>
          <span title="导出数据" class="icon-box" @click="exportShopStoreList">
            <Icon color="#606266">
              <ArrowDownload24Regular />
            </Icon>
          </span>
          <span class="icon-box" @click="refreshShopStoreList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="shopStoreList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <!-- <el-table-column align="center" type="selection" width="60"> </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" align="center" prop="storeName" label="门店名称" width="180">
        </el-table-column>
        <el-table-column align="center" prop="storePic" label="门店图片" width="180">
          <template slot-scope="scope">
            <div v-if='scope.row.storePic'>
              <el-image @click='updateSrcList(scope.row.storePic)' style="width: 60px; height: 60px"
                :src="scope.row.storePic" :preview-src-list="srcList"> </el-image>
              </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="contactPerson" label="联系" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.contactPerson">
              <div style="text-align: left">姓名：{{ scope.row.contactPerson }}</div>
              <div style="text-align: left">电话：{{ scope.row.contactPhone }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="storeAddress" label="地址" width="180">
            <template slot-scope="scope">
                <div v-if="scope.row.storeAddress">
                    <div style="text-align: left">省：{{ scope.row.province.areaName}}</div>
                    <div style="text-align: left">市：{{ scope.row.city.areaName }}</div>
                    <div style="text-align: left">区：{{ scope.row.area.areaName }}</div>
                    <div style="text-align: left">详细地址：{{ scope.row.storeAddress }}</div>
                </div>
                <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="300">
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopStore(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <!-- <div @click="editShopStore(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopStore(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="shopStoreStates[shopStoreState]" :visible.sync="showDialog" width="60%" :modal="false" @close="closeDialog">
        <div>
          <el-form :model="shopStore" ref="shopStoreForm" :rules="rules" label-width="120px" :inline="true" size="small">
            <el-form-item label="门店名称" prop="storeName">
              <el-input size="small" v-model="shopStore.storeName" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="省" prop="provinceId">
              <!-- <el-input size="small" v-model="shopStore.provinceId" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-select
                placeholder='请选择省'
                @change="clearSubitem('province')"
                clearable
                style='width: 177px'
                size='small'
                v-model='shopStore.provinceId'
                :disabled="shopStoreState == 'check'"
              >
                <el-option
                  v-for='(item,index) in provinceArry'
                  :key='index'
                  :label='item.areaName'
                  :value='item.id'
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市" prop="cityId">
              <!-- <el-input size="small" v-model="shopStore.cityId" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-select
                  placeholder='请选择市'
                  @change="clearSubitem('city')"
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='shopStore.cityId'
                  :disabled="shopStoreState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in cityArry'
                      :key='index'
                      :label='item.areaName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区" prop="areaId">
              <!-- <el-input size="small" v-model="shopStore.areaId" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-select
                    placeholder='请选择区'
                    clearable
                    style='width: 177px'
                    size='small'
                    v-model='shopStore.areaId'
                    :disabled="shopStoreState == 'check'"
                >
                    <el-option
                        v-for='(item,index) in areaArry'
                        :key='index'
                        :label='item.areaName'
                        :value='item.id'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址" prop="storeAddress">
              <location
                style='width: 177px;'
                :areaTreeDate="areaTreeDate"
                :longitude="shopStore.storePosition.split(',')[0]"
                :latitude="shopStore.storePosition.split(',')[1]"
                :provinceId="shopStore.provinceId"
                :cityId="shopStore.cityId"
                :areaId="shopStore.areaId"
                :address="shopStore.storeAddress"
                :disabled="shopStoreState == 'check'"
                @getLocation="getLocation"
              ></location>
            </el-form-item>
            <el-form-item label="定位" prop="storePosition">
              <el-input size="small" v-model="shopStore.storePosition" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="经度" prop="longitude">
              <el-input size="small" v-model="shopStore.longitude" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="纬度" prop="latitude">
              <el-input size="small" v-model="shopStore.latitude" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="营业状态" prop="openStatus">
              <el-input size="small" v-model="shopStore.openStatus" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="营业时间" prop="openHours">
              <!-- <el-input size="small" v-model="shopStore.openHours" :disabled="shopStoreState == 'check'"></el-input> -->
              <el-time-picker
                  :disabled="shopStoreState == 'check'"
                  is-range
                  style="width: 177px;"
                  v-model="shopStore.openHours"
                  range-separator="至"
                  format='HH:mm:ss'
                  value-format='HH:mm:ss'
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="联系人姓名" prop="contactPerson">
              <el-input size="small" v-model="shopStore.contactPerson" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="contactPhone">
              <el-input size="small" v-model="shopStore.contactPhone" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
              <el-input size="small" v-model="shopStore.remarks" :disabled="shopStoreState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="门店管理" prop="userId">
              <!-- <el-input size="small" v-model="shopStore.userId" :disabled="shopStoreState == 'check'"></el-input> -->
              <GridSelectU style="width: 177px;" title="选择管理员" labelName="userName" :disabled="shopStoreState == 'check'"
                labelValue="id" :value="shopStore.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
            </el-form-item>
            <el-form-item label="门店图片" prop="storePic">
              <!-- <el-input size="small" v-model="shopStore.storePic" :disabled="shopStoreState == 'check'"></el-input>  -->
              <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                :disabled="shopStoreState == 'check'" class="avatar-uploader" :show-file-list="false"
                :http-request="uploadImage">
                <img v-if="shopStore.storePic" :src="shopStore.storePic" class="avatar" size="small" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="shopStoreState != 'check'">确定</el-button>
        </div>
      </el-dialog>
    </div>
    </el-drawer>
  </template>
  
  <script>
  import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
  import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
  import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
  import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
  import Location from '@/components/location/location.vue';
  import { UPLOAD_PATH, UPLOAD_API, USER, USER_SEARCH } from '@/utils/constant.js';
  import GridSelectU from '@/components/gridselect';
  
  export default {
    props:{
        id: {
          type: String,
          default: ''
        }
    },
    components: {
      Edit24Regular,
      Delete24Regular,
      Eye24Regular,
      GridDots,
      Refresh,
      Printer,
      ArrowUp,
      ArrowDown,
      ArrowDownload24Regular,
      ArrowExportUp24Regular,
      Search,
      Location,
      GridSelectU
    },
    watch: {
      checkState(val) {
        if (val == 'check') {
          this.resetShopStoreList();
          this.getShopStoreList(this.queryForm);
          this.$emit('resetCheckState');
        } else if (val == 'reset') {
          this.resetShopStoreList();
          this.getShopStoreList();
          this.$emit('resetCheckState');
        }
      }
    },
    computed: {
      provinceArry() {
          return this.areaTreeDate;
      },
      cityArry() {
        if (!this.provinceArry) {
          return [];
        } else {
          for (let i = 0; i < this.provinceArry.length; i++) {
            if (this.provinceArry[i].id == this.shopStore.provinceId) {
              return this.provinceArry[i].children;
            } else if (this.shopStore.provinceId == '') {
              return [];
            }
          }
        }
      },
      areaArry() {
        if (!this.cityArry) {
          return [];
        } else {
          for (let i = 0; i < this.cityArry.length; i++) {
            if (this.cityArry[i].id == this.shopStore.cityId) {
                return this.cityArry[i].children;
            }
          }
        }
      }
    },
    data() {
      return {
        USER_code: USER,
        USER_search: USER_SEARCH,
        queryForm: {
          deliverId:'',
          sortingId: '',
        },
        header: {
          token: localStorage.getItem('token')
        },
        action: UPLOAD_API + UPLOAD_PATH,
        areaTreeDate:[],
        srcList: [''],
        loading: false,
        showDialog: false,
        isImportDate: false,
        isSearch: false,
        pageSize: 10,
        currentPage: 1,
        totalNum: 0,
        currentUserId: '',
        shopStoreState: 'add',
        shopStoreStates: {
          add: '新建门店',
          check: '查看门店',
          edit: '修改门店'
        },
  
        multipleSelection: [],
        shopStoreList: [],
        shopStore: {
          storeName: '', //门店名称
          storePic: '', //门店图片
          provinceId: '', //省
          cityId: '', //市
          areaId: '', //区
          storeAddress: '', //详细地址
          storePosition: '', //定位
          longitude: '', //经度
          latitude: '', //纬度
          openStatus: '', //营业状态
          openHours: ['08:00:00','20:00:00'], //营业时间
          contactPerson: '', //联系人姓名
          contactPhone: '', //联系人电话
          remarks: '', //备注
          userId: '', //店铺管理
        },
        btnLoading: false,
        isShow:false,
        rules: {
          storeName: [{ required: true, message: '门店名称不能为空', trigger: 'blur' }],
          storePic: [{ required: true, message: '门店图片不能为空', trigger: 'blur' }],
          provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
          cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
          areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
          storeAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
          storePosition: [{ required: true, message: '定位不能为空', trigger: 'blur' }],
          longitude: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
          latitude: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
          openStatus: [{ required: true, message: '营业状态不能为空', trigger: 'blur' }],
          openHours: [{ required: true, message: '营业时间不能为空', trigger: 'blur' }],
          contactPerson: [{ required: true, message: '联系人姓名不能为空', trigger: 'blur' }],
          contactPhone: [{ required: true, message: '联系人电话不能为空', trigger: 'blur' }],
          remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
          userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }]
        }
      };
    },
    created() {
      this.getTreeData();
    },
    methods: {
        beforeImageUpload(file) {
          const isLt2M = file.size / 1024 / 1024 < 50;
          if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 50MB!');
          }
          return isLt2M;
        },
        init() {
            this.isShow = true;
            console.log(this.id);
            this.queryForm.deliverId = this.id;
            this.getShopStoreList();
        },
        init1(){
          this.isShow = true;
          this.queryForm.sortingId = this.id;
          this.getShopStoreList();
        },
        closeDrawer() {
            this.isShow = false;
            this.shopStoreList = [];
            this.shopStoreList = 0;
        },
      clearSubitem(id) {
        if (id == 'province') {
            this.shopStore.cityId = '';
            this.shopStore.areaId = '';
        } else if (id == 'city') {
            this.shopStore.areaId = '';
        }
      },
      getValueUser(value) {
        this.shopStore.userId = value
      },
      //上传缩略图
      uploadImage(params) {
        const file = params.file;
        let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
        if (!types.includes(file.type)) {
          this.$message.error('图片类型错误!');
        }
        const formData = new FormData();
        formData.append('file', file);
        upload(UPLOAD_PATH, formData).then((res) => {
          if (res.success) {
            this.shopStore.storePic = res.url;
          }
        });
      },
      getLocation(location){
        this.shopStore.storePosition = `${location.lng},${location.lat}`
        this.shopStore.storeAddress = location.address
        this.shopStore.provinceId = location.province
        this.shopStore.cityId = location.city
        this.shopStore.areaId = location.area
        this.shopStore.longitude = location.lng
        this.shopStore.latitude = location.lat
      },
      getTreeData() {
        get('/mpp/area/treeData').then((res) => {
          if (res.success) {
            this.areaTreeDate = res.treeData[0].children;
          }
        });
      },
      // 大图预览
      updateSrcList(src) {
        this.srcList[0] = src
      },
      search() {
        this.isSearch = !this.isSearch;
      },
      resetShopStoreList() {
        this.pageSize = 10;
        this.currentPage = 1;
        this.shopStoreList = [];
      },
      resetDialog() {
        this.shopStoreState = 'add';
        this.showDialog = false;
        this.queryForm = {
          id: '', //ID
          storeName: '', //门店名称
          storePic: '', //门店图片
          provinceId: '', //省
          cityId: '', //市
          areaId: '', //区
          storeAddress: '', //详细地址
          storePosition: '', //定位
          longitude: '', //经度
          latitude: '', //纬度
          openStatus: '', //营业状态
          openHours: '', //营业时间
          contactPerson: '', //联系人姓名
          contactPhone: '', //联系人电话
          remarks: '', //备注
          userId: '', //店铺管理
          createTime: '', //创建时间
        };
        this.getShopStoreList();
      },
      closeDialog() {
        this.showDialog = false
        this.shopStore = {
          id: '', //ID
          storeName: '', //门店名称
          storePic: '', //门店图片
          provinceId: '', //省
          cityId: '', //市
          areaId: '', //区
          storeAddress: '', //详细地址
          storePosition: '', //定位
          longitude: '', //经度
          latitude: '', //纬度
          openStatus: '', //营业状态
          openHours:['08:00:00','20:00:00'], //营业时间
          contactPerson: '', //联系人姓名
          contactPhone: '', //联系人电话
          remarks: '', //备注
          userId: '', //店铺管理
          createTime: '', //创建时间
        };
      },
      submitForm() {
        if (this.shopStoreState == 'add') {
          this.$refs.shopStoreForm.validate((valid) => {
            if (valid) {
              console.log('submit');
              this.shopStore.openHours = this.shopStore.openHours.join('-')
              post(`/washcloud/store/add`, { ...this.shopStore }).then((res) => {
                if (res.success) {
                  this.$message({
                    message: res.msg,
                    type: 'success',
                    duration: 2000,
                  });
                  this.resetShopStoreList();
                  this.resetDialog();
                } else {
                  this.shopStore.openHours = this.shopStore.openHours.split('-')
                  this.$message({
                    message: res.msg,
                    type: 'error',
                    duration: 2000
                  });
                }
              });
            }
          });
        } else if (this.shopStoreState == 'edit') {
          this.$refs.shopStoreForm.validate((valid) => {
            if (valid) {
              console.log('submit');
              let params = {...this.shopStore };
              delete params.user
              delete params.area
              delete params.city
              delete params.province
              params.openHours = params.openHours.join('-')
              console.log(params)
              post(`/washcloud/store/edit`, params ).then((res) => {
                if (res.success) {
                  this.$message({
                    message: res.msg,
                    type: 'success',
                    duration: 2000
                  });
                  this.resetShopStoreList();
                  this.resetDialog();
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error',
                    duration: 2000
                  });
                }
              });
            }
          });
        }
      },
      addShopStore() {
        this.showDialog = true;
        this.shopStoreState = 'add';
      },
      checkShopStore(shopStoreId) {
        console.log(shopStoreId);
        this.currentShopStoreId = shopStoreId;
  
        this.getShopStoreById();
        this.showDialog = true;
        this.shopStoreState = 'check';
      },
      editShopStore(shopStoreId) {
        console.log('shopStore', shopStoreId);
        if (shopStoreId) {
          this.currentShopStoreId = shopStoreId;
          this.getShopStoreById();
        } else {
          this.shopStore = { ...this.shopStore, ...this.multipleSelection[0] };
        }
  
        this.showDialog = true;
        this.shopStoreState = 'edit';
      },
      deleteShopStore(shopStoreId) {
        let ids = '';
        if (shopStoreId) {
          ids = shopStoreId;
        } else {
          ids = this.multipleSelection.map((shopStore) => shopStore.id).join(',');
        }
        console.log({ ids });
        this.$confirm('确定删除所选项吗？', '提示', {
          type: 'warning'
        })
          .then(() => {
            deleteFun(`/washcloud/store/delete`, { ids }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetShopStoreList();
                this.getShopStoreList();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          })
          .catch(() => { });
      },
      refreshShopStoreList() {
        this.resetShopStoreList();
        this.getShopStoreList();
      },
      getShopStoreList(query = {}) {
        this.loading = true;
        console.log(this.queryForm)
        get(`/washcloud/store/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
          this.loading = false;
          if (res.success) {
            this.shopStoreList = res.page.list;
            this.totalNum = res.page.total;
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 2000
            });
          }
        });
      },
      getShopStoreById() {
        get(`/washcloud/store/get`, { id: this.currentShopStoreId }).then((res) => {
          if (res.success) {
            this.shopStore = { ...this.shopStore, ...res.shopStore };
            this.shopStore.openHours = this.shopStore.openHours.split('-');
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 2000
            });
          }
        });
      },
      /**
       * 导出信息
       */
      exportShopStoreList() {
        //this.btnLoading = true;
        exprotExcel(`/washcloud/store/export`, { ...this.queryForm });
      },
      /**
       * 导出模板
       */
      importTemplate() {
        this.btnLoading = true;
        importTemplate(`/washcloud/store/importTemplate`, this.btnLoading);
      },
      /**
       * 导入数据
       */
      isImport() {
        this.isImportDate = !this.isImportDate;
      },
      upload(params) {
        const file = params.file;
        const formData = new FormData();
        formData.append('file', file);
        console.log({ formData });
        importDate(`/washcloud/store/importData`, formData);
        this.refreshShopStoreList();
      },
      handleSelectionChange(value) {
        console.log(value);
        this.multipleSelection = value;
      },
      currentChange(page) {
        this.currentPage = page;
        this.getShopStoreList();
      },
      sizeChange(size) {
        this.pageSize = size;
        this.getShopStoreList();
      }
    }
  
  };
  </script>
  
  <style lang="scss" scoped>
   ::v-deep .el-dialog {
      height: 80%;
  }
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  ::v-deep .el-dialog__body {
      height: 80%;
  }
  
  ::v-deep .el-dialog__footer {
      height: 15%;
  }
  ::v-deep .el-dialog-div {
      height: 100%;
  }
  .page-content {
      height: 500px;
  }
  .avatar {
    width: 177px;
    height: 177px;
    display: block;
  }
  
  ::v-deep .el-upload--text {
    width: 177px;
    height: 177px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  ::v-deep .el-range-separator{
    width: 20px;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 180px;
    text-align: center;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;
  
    &>div {
      display: flex;
      align-items: center;
      padding: 0 5px;
      cursor: pointer;
    }
  
    .operation-label {
      margin-left: 3px;
    }
  }
  </style>
  
  <!-- <style lang="scss" scoped>
  ::v-deep .el-dialog {
      height: 80%;
  }
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  ::v-deep .el-dialog__body {
      height: 80%;
  }
  
  ::v-deep .el-dialog__footer {
      height: 15%;
  }
  ::v-deep .el-dialog-div {
      height: 100%;
  }
  .page-content {
      height: 500px;
  }
  .operation {
      display: flex;
      align-items: center;
      justify-content: center;
  
      color: #409eff;
      font-size: 12px;
  
      & > div {
          display: flex;
          align-items: center;
          padding: 0 5px;
          cursor: pointer;
      }
  
      .operation-label {
          margin-left: 3px;
          cursor: pointer;
      }
  }
  </style> -->
  